export const fsiTheme= {
    header: '#52688F',
    headerShadow: '#B5C3D6',
    background: '#E3E7F1',
    secondaryBackground: '#BDC6D9',
    footer: '#B5C3D6',
    button: '#7391C8',
    buttonText: '#e4ecec',
    separator: '#7391C8'
}